import api from '../../../services/api';

const BASE = (id) => `/api/production-studio/productions/${id}/review`;

export async function getProductionReviewSummary(id) {
  return api.get(`${BASE(id)}/summary`);
}

export async function getProductionReviewScenes(id) {
  return api.get(`${BASE(id)}/scenes`);
}

export async function setProductionReviewSceneStatus(id, sceneId, sceneStatus, patch) {
  return api.patch(`${BASE(id)}/scenes/${sceneId}/status`, { sceneStatus, patch });
}

export async function approveProductionReviewScene(id, sceneId) {
  return api.post(`${BASE(id)}/scenes/${sceneId}/approve`, {});
}

export async function rejectProductionReviewScene(id, sceneId) {
  return api.post(`${BASE(id)}/scenes/${sceneId}/reject`, {});
}

export async function approveAllProductionReviewScenes(id) {
  return api.post(`${BASE(id)}/approve-all`, {});
}

export async function setProductionReviewScenePrompt(id, sceneId, prompt) {
  return api.patch(`${BASE(id)}/scenes/${sceneId}/prompt`, { prompt });
}

export async function regenerateProductionReviewScene(id, sceneId, payload) {
  return api.post(`${BASE(id)}/scenes/${sceneId}/regenerate`, payload || {});
}

export async function regenerateProductionReviewRejected(id) {
  return api.post(`${BASE(id)}/regenerate-rejected`, {});
}

export async function uploadProductionReviewSceneImage(id, sceneId, file, onProgress) {
  const form = new FormData();
  form.append('file', file);
  return api.upload(`${BASE(id)}/scenes/${sceneId}/upload`, form, { onProgress });
}

export async function selectProductionReviewSceneVersion(id, sceneId, versionId) {
  return api.patch(`${BASE(id)}/scenes/${sceneId}/versions/${versionId}/select`, {});
}
